import { Fragment, useEffect, useState } from "react";
import { formatCurrency } from "src/utils/FormatCurrency";
import { GiftCardTransactionDetailSummaryModel } from "src/models/GiftCardTransactionDetailSummaryModel";
import { AmountTotalType } from "src/models/AmountTotalType";
import { TransactionTypeCount } from "src/models/TransactionTypeCount";

type GiftCardTransactionDetailSummaryDataProps = {
  summaryDetail: GiftCardTransactionDetailSummaryModel;  
};

const GiftCardTransactionDetailSummaryData = ({
  summaryDetail,
}: GiftCardTransactionDetailSummaryDataProps) => {  
  const [summaryData, setSummaryData] = useState<GiftCardTransactionDetailSummaryModel>({} as GiftCardTransactionDetailSummaryModel);

  useEffect(() => {
    if (summaryDetail) {
      setSummaryData(summaryDetail)
    }
  }, [summaryDetail]);

  return (    
      <div className="">
        <div className="row">          
          <div className="col-6 summary-data">            
            {summaryData?.amountTypes?.map(
              (t: AmountTotalType, idx: number) => (
                <Fragment key={`amountTotals-${idx}`}>
                  <div className="grouping1">
                    <div>Total Sales</div>
                    <div>
                      {formatCurrency(t.totalSalesAmount, t.currencyAlphaCode)}
                    </div>
                  </div>
                  <div className="grouping2" >
                    <div>Total Card Amount</div>
                    <div>
                      {formatCurrency(t.totalCardAmount, t.currencyAlphaCode)}
                    </div>
                  </div>
                  <div className="grouping3">
                    <div>Total Property Fees</div>
                    <div>
                      {formatCurrency(t.totalPropertyFees, t.currencyAlphaCode)}
                    </div>
                  </div>
                </Fragment>
              )
            )}
            </div>
            <div className="col-6 summary-data">
            {summaryData?.transactionTypeCounts?.map(
              (t: TransactionTypeCount, idx: number) => (
                <Fragment key={`tranactionTypes-${idx}`}>
                  <div className="grouping" key={`${t.description}-${idx}`}>
                    <div key={`${t.description}-${idx}-label`}>{t.description}</div>
                    <div key={`${t.description}-${idx}-desc`}>
                      {t.count}
                    </div>
                  </div>
                </Fragment>
              )
            )}
          </div>
        </div>
      </div>    
  );
};

export default GiftCardTransactionDetailSummaryData;
